import {
    Component,
    Element,
    Event,
    EventEmitter,
    h,
    Host,
} from '@stencil/core';

@Component({
    tag: 'portal-lazy',
    shadow: true,
})
export class PortalLazy {

    /**
   * Event emitted when the host component is scrolled into the view
   */
    @Event({
        eventName: 'loadMoreNotification',
        composed: true,
        cancelable: true,
        bubbles: true,
    }) loadMoreNotification: EventEmitter<void>;

    @Element() host: HTMLPortalLazyElement;
    private io: IntersectionObserver;

    componentDidLoad() {
        this.io = new IntersectionObserver(([ entry ]) => entry.isIntersecting && this.loadMoreNotification.emit(), {});
        this.io.observe(this.host);
    }

    render() {
        return <Host></Host>;
    }
}
